var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-container',{staticClass:"mt-3"},[_c('p',[_vm._v(" "+_vm._s(_vm.t("Introduction text"))+" ")]),_c('p',[_vm._v(" "+_vm._s(_vm.t("Note regarding estimates"))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }